import request from '@/utils/request';
export function customerFsSelect(params) {
  return request({
    url: '/orders/customer/fs-select',
    method: 'get',
    params: params
  });
}
export function getCustomerTypeList(params) {
  return request({
    url: '/user/customer/get-customer-type-list',
    method: 'get',
    params: params
  });
}

// 获取单一，公海查询日志,获取批量查询日志
export function getAllLogList(data) {
  return request({
    url: '/orders/general-log/list',
    method: 'post',
    data: data
  });
}
// 查看导入详情
export function getImportDetails(data) {
  return request({
    url: '/orders/general-log/export-list',
    method: 'post',
    data: data
  });
}
// 二维码解码
export function decode(data) {
  return request({
    url: '/sales/tools/decode',
    method: 'post',
    data: data
  });
}
// 获取交付方式
export function getSeasList(params) {
  return request({
    url: '/user/customer/open-sea',
    method: 'get',
    params: params,
    timeout: 3 * 60 * 1000
  });
}
// 二维码提示文字
export function getInvoiceTips(params) {
  return request({
    url: '/products/page-description/get-invoice-tips-no-auth',
    method: 'get',
    params: params
  });
}
// 领取客户
export function claimCustomer(params) {
  return request({
    url: '/user/customer/get-customer',
    method: 'get',
    params: params
  });
}
// 领取客户信息
export function getClaimCustomer(params) {
  return request({
    url: '/user/customer/get-customer-info',
    method: 'get',
    params: params
  });
}
// 领取客户
export function customerCheckRepeat(params) {
  return request({
    url: '/user/customer/check-repeat',
    method: 'get',
    params: params
  });
}
// 获取省市区数据
export function getCity(data) {
  return request({
    url: '/user/customer/city',
    method: 'post',
    data: data
  });
}
export function jumpOpensea(data) {
  return request({
    url: '/user/customer/jump-opensea',
    method: 'post',
    data: data
  });
}
// 提交仲裁
export function applyArbitration(data) {
  return request({
    url: '/user/customer/apply-arbitration',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
// 领取/划转审核列表
export function auditCustomerList(data) {
  return request({
    url: '/user/customer/audit-customer',
    method: 'post',
    data: data
  });
}
// 提交仲裁
export function subAudit(data) {
  return request({
    url: '/user/customer/audit',
    method: 'post',
    data: data
  });
}
// 获取审核详情
export function getAuditInfo(data) {
  return request({
    url: '/user/customer/audit-info',
    method: 'post',
    data: data
  });
}
// 修改审核人
export function upAuditUser(data) {
  return request({
    url: '/user/customer/up-audit',
    method: 'post',
    data: data
  });
}

// 我的商城账号列表
export function getShopAccount(params) {
  return request({
    url: '/user/shop-account/index',
    method: 'get',
    params: params
  });
}

// 更改账号状态
export function changeUserStataus(data) {
  return request({
    url: '/user/shop-account/change-user-status',
    method: 'post',
    data: data
  });
}

// 清除用户登录状态
export function clearLoginStatus(params) {
  return request({
    url: '/user/shop-account/sign-out',
    method: 'get',
    params: params
  });
}

// 获取用户登录信息
export function getWechatInformation(params) {
  return request({
    url: '/user/shop-account/get-wechat-information',
    method: 'get',
    params: params
  });
}

// 设置默认账号
export function setDefaultAccount(data) {
  return request({
    url: '/user/shop-account/set-default-account',
    method: 'post',
    data: data
  });
}

// 获取用户公司列表
export function getAccountList(params) {
  return request({
    url: '/user/shop-account/get-account',
    method: 'get',
    params: params
  });
}

//获取日志
export function getShopUserLog(params) {
  return request({
    url: '/user/shop-account/get-log',
    method: 'get',
    params: params
  });
}

//获取日志类型
export function getShopUserLogType(params) {
  return request({
    url: '/user/shop-account/get-type',
    method: 'get',
    params: params
  });
}
// 解码操作日志
export function getCodeLog(params) {
  return request({
    url: '/sales/tools/get-code-log',
    method: 'get',
    params: params
  });
}
// 获取当前登录人贡献点
export function getCustomerPoint(data) {
  return request({
    url: '/user/customer/get-customer-point',
    method: 'post',
    data: data
  });
}
// 单一查重退回
export function returnCustomer(data) {
  return request({
    url: '/user/customer/return',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
// 联系人系统存不存在
export function getArbitrationContact(data) {
  return request({
    url: '/user/customer/get-arbitration-contact',
    method: 'post',
    data: data
  });
}
// 我发起的列表（个性化项目工单）
export function getInitiatedByMe(data) {
  return request({
    url: '/user/project-delivery/ticket-initiated-by-me',
    method: 'post',
    data: data
  });
}

// 我待办的列表
export function getMyToDoList(data) {
  return request({
    url: '/user/project-delivery/my-to-do',
    method: 'post',
    data: data
  });
}

// 我的审核-统计
export function getMyReviewAuditCount(data) {
  return request({
    url: '/user/project-delivery/my-review',
    method: 'post',
    data: data
  });
}

// 我的审核-项目列表
export function getMyApprovalProjectList(data) {
  return request({
    url: '/user/project-delivery/my-audit-project',
    method: 'post',
    data: data
  });
}

// 我的审核-商城装修
export function getMyApprovalMallList(data) {
  return request({
    url: '/user/project-delivery/my-audit-mall',
    method: 'post',
    data: data
  });
}

// 我的审核-定制设计及印刷
export function getMyApprovalPrintingList(data) {
  return request({
    url: '/user/project-delivery/my-audit-printing',
    method: 'post',
    data: data
  });
}

// 我的待办-定制设计及印刷导出
export function getMyToDoPrintingExcel(data) {
  return request({
    url: '/user/project-delivery/my-to-do-printing-excel',
    method: 'post',
    data: data
  });
}

// 全部待办-定制设计及印刷导出
export function getAllToDoPrintingExcel(data) {
  return request({
    url: '/user/project-delivery/all-to-do-printing-excel',
    method: 'post',
    data: data
  });
}

// 全部待办-项目列表导出
export function getAllToDoProjectExcel(data) {
  return request({
    url: '/user/project-delivery/all-project-list-excel',
    method: 'post',
    data: data
  });
}

// 调整投标任务状态
export function modifyBiddingStatus(data) {
  return request({
    url: '/user/project-delivery/modify-bidding-status',
    method: 'post',
    data: data
  });
}

// 调整定制设计及印刷任务状态
export function modifyPrintingStatus(data) {
  return request({
    url: '/user/project-delivery/modify-printing-status',
    method: 'post',
    data: data
  });
}

// 上传开标结果
export function biddingUploadResults(data) {
  return request({
    url: '/user/project-delivery/bidding-upload-results',
    method: 'post',
    data: data
  });
}

// 项目交付
export function biddingDelivery(data) {
  return request({
    url: '/user/project-delivery/bidding-delivery',
    method: 'post',
    data: data
  });
}

// 编辑开标&交付信息
export function bidOpeningDeliveryInformationEdit(data) {
  return request({
    url: '/user/project-delivery/bid-opening-delivery-information-edit',
    method: 'post',
    data: data
  });
}

// 创建申请
export function createProjectDelivery(data) {
  return request({
    url: '/user/project-delivery/create-project-delivery',
    method: 'post',
    data: data
  });
}

// 申请详情
export function getProjectDeliveryDetail(params) {
  return request({
    url: '/user/project-delivery/view',
    method: 'get',
    params: params
  });
}

// 获取任务详情（上传标书弹窗回显）
export function getTaskInfo(params) {
  return request({
    url: '/user/project-delivery/get-task-info',
    method: 'get',
    params: params
  });
}

// 再次申请
export function launchedAgain(data) {
  return request({
    url: '/user/project-delivery/launched-again',
    method: 'post',
    data: data
  });
}

// 项目审核
export function auditProjectDelivery(data) {
  return request({
    url: '/user/project-delivery/my-approval-project',
    method: 'post',
    data: data
  });
}

// 任务审核
export function auditProjectTask(data) {
  return request({
    url: '/user/project-delivery/my-approval-task',
    method: 'post',
    data: data
  });
}

// 报价单审核（audit：1通过 2拒绝）
export function auditQuotationApproval(data) {
  return request({
    url: '/user/project-delivery/my-approval-quotation',
    method: 'post',
    data: data
  });
}

// 日志列表
export function getProjectDeliveryLog(params) {
  return request({
    url: '/user/project-delivery/log',
    method: 'get',
    params: params
  });
}

// 查询装修处理结果 - 已废弃
export function getProjectDeliveryHandleType(params) {
  return request({
    url: '/user/project-delivery/get-handle-type',
    method: 'get',
    params: params
  });
}

//提交装修处理结果
export function submitProjectDeliveryHandle(data) {
  return request({
    url: '/user/project-delivery/handle',
    method: 'post',
    data: data
  });
}

//装修验收
export function submitProjectDeliveryAcceptance(data) {
  return request({
    url: '/user/project-delivery/acceptance',
    method: 'post',
    data: data
  });
}

// 获取装修负责人选项
export function getProjectDeliveryHandleUser(params) {
  return request({
    url: '/package/package-programme/user-ids',
    method: 'get',
    params: params
  });
}

// 负责人类下拉-按关键字远程搜索人员
export function searchUserList(data) {
  return request({
    url: '/user/project-delivery/user-list-search',
    method: 'post',
    data: data
  });
}

// 获取项目负责人选项
export function getProjectManager(params) {
  return request({
    url: '/user/project-delivery/get-project-manager',
    method: 'get',
    params: params
  });
}

// 获取报价单审批人状态：data 为 {status, message}，status=1 表示审批人信息不完整
export function getProjectDeliveryLeader(params) {
  return request({
    url: '/user/project-delivery/get-leader',
    method: 'get',
    params: params
  });
}

//我的待办-项目列表
export function getMyToDoProjectList(data) {
  return request({
    url: '/user/project-delivery/my-to-do-project',
    method: 'post',
    data: data
  });
}

//我的待办-商城装修
export function getMyToDoMallList(data) {
  return request({
    url: '/user/project-delivery/my-to-do-mall',
    method: 'post',
    data: data
  });
}

//我的待办-投标支持
export function getMyToDoBiddingList(data) {
  return request({
    url: '/user/project-delivery/my-to-do-bidding',
    method: 'post',
    data: data
  });
}

//我的待办-定制设计印刷
export function getMyToDoCardAndCouponDesignList(data) {
  return request({
    url: '/user/project-delivery/my-to-do-printing',
    method: 'post',
    data: data
  });
}

//全部待办-项目列表
export function getAllToDoProjectList(data) {
  return request({
    url: '/user/project-delivery/all-project-list',
    method: 'post',
    data: data
  });
}

//全部待办-任务列表
export function getAllToDoTaskList(data) {
  return request({
    url: '/user/project-delivery/all-task-list',
    method: 'post',
    data: data
  });
}

//全部待办-全部任务列表任务状态筛选项
export function getAllTaskSelect(data) {
  return request({
    url: '/user/project-delivery/all-task-select',
    method: 'post',
    data: data
  });
}

//全部待办-商城装修
export function getAllToDoMallList(data) {
  return request({
    url: '/user/project-delivery/all-to-do-mall',
    method: 'post',
    data: data
  });
}

//全部待办-投标支持
export function getAllToDoBiddingList(data) {
  return request({
    url: '/user/project-delivery/all-to-do-bidding',
    method: 'post',
    data: data
  });
}

//全部待办-定制设计及印刷
export function getAllToDoPrintingList(data) {
  return request({
    url: '/user/project-delivery/all-to-do-printing',
    method: 'post',
    data: data
  });
}

// 我的待审核-报价单审核
export function getMyAuditQuotationList(data) {
  return request({
    url: '/user/project-delivery/my-audit-quotation',
    method: 'post',
    data: data
  });
}

// 我的待审核-报价单分发
export function getMyAuditQuotationBindList(data) {
  return request({
    url: '/user/project-delivery/my-audit-quotation-bind',
    method: 'post',
    data: data
  });
}

// 我的待审核-报价单分发-分配负责人
export function quotationAllocation(data) {
  return request({
    url: '/user/project-delivery/quotation-allocation',
    method: 'post',
    data: data
  });
}

// 我的待办-报价单配置
export function getMyToDoQuotationList(data) {
  return request({
    url: '/user/project-delivery/my-to-do-quotation',
    method: 'post',
    data: data
  });
}

// 全部待办-报价单配置
export function getAllToDoQuotationList(data) {
  return request({
    url: '/user/project-delivery/all-to-do-quotation',
    method: 'post',
    data: data
  });
}

// 我的待办-列表个数统计
export function getMyToDoCount(data) {
  return request({
    url: '/user/project-delivery/my-to-do',
    method: 'post',
    data: data
  });
}

// 全部待办-列表个数统计
export function getAllToDoCount(data) {
  return request({
    url: '/user/project-delivery/all-to-do',
    method: 'post',
    data: data
  });
}

//项目处理
export function submitProjectHandle(data) {
  return request({
    url: '/user/project-delivery/project-handle',
    method: 'post',
    data: data
  });
}

// 个性化项目评估详情
export function getProjectPassDetail(params) {
  return request({
    url: '/user/project-delivery/project-pass-detail',
    method: 'get',
    params: params
  });
}

//项目过会
export function submitProjectLater(data) {
  return request({
    url: '/user/project-delivery/project-later',
    method: 'post',
    data: data
  });
}

//投标处理
export function submitBiddingHandle(data) {
  return request({
    url: '/user/project-delivery/bid-handle',
    method: 'post',
    data: data
  });
}

// 获取商机信息（新接口）
export function getUserOpportunity(params) {
  return request({
    url: '/user/project-delivery/get-user-opportunity-data',
    method: 'get',
    params: params
  });
}

//定制设计印刷处理
export function submitCardAndCouponDesignHandle(data) {
  return request({
    url: '/user/project-delivery/printing-handle',
    method: 'post',
    data: data
  });
}

//定制设计确认
export function submitCardAndCouponDesignConfirm(data) {
  return request({
    url: '/user/project-delivery/printing-acceptance',
    method: 'post',
    data: data
  });
}

// 跟进
export function followUp(data) {
  return request({
    url: '/user/project-delivery/follow-up',
    method: 'post',
    data: data
  });
}

// 咨询工单-跟进
// 参数：id 工单id, remark 跟进记录
export function followUpProjectTicket(data) {
  return request({
    url: '/user/project-ticket/follow-up',
    method: 'post',
    data: data
  });
}

// 编辑其他供应商
export function editOtherSuppliers(data) {
  return request({
    url: '/user/project-delivery/suppliers-edit',
    method: 'post',
    data: data
  });
}

// 历史成交供应商搜索
export function searchWinBidSupplier(params) {
  return request({
    url: '/user/project-delivery-reference/win-bid-search',
    method: 'get',
    params: params
  });
}

// 编辑报价单
export function editQuotationSheet(data) {
  return request({
    url: '/user/project-delivery/quotation-sheet-edit',
    method: 'post',
    data: data
  });
}

// 编辑投标信息
export function editBidLetter(data) {
  return request({
    url: '/user/project-delivery/bid-letter-edit',
    method: 'post',
    data: data
  });
}

// 编辑商城装修
export function editShopDecoration(data) {
  return request({
    url: '/user/project-delivery/shop-decoration-edit',
    method: 'post',
    data: data
  });
}

// 编辑定制设计及印刷
export function editCustomDesign(data) {
  return request({
    url: '/user/project-delivery/custom-design-edit',
    method: 'post',
    data: data
  });
}

// 编辑需求项说明
export function editRequirementProject(data) {
  return request({
    url: '/user/project-delivery/requirement-project-edit',
    method: 'post',
    data: data
  });
}

// 编辑项目信息
export function editPersonalizedProject(data) {
  return request({
    url: '/user/project-delivery/personalized-project-edit',
    method: 'post',
    data: data
  });
}

// 获取设计稿
export function getPrintingInfo(params) {
  return request({
    url: '/user/project-delivery/get-printing-info',
    method: 'get',
    params: params
  });
}

// 获取业务类型
export function getBusinessType(data) {
  return request({
    url: '/user/project-delivery/get-channel-group',
    method: 'post',
    data: data
  });
}
// 获取卡类型
export function getAddOrderCardType(data) {
  return request({
    url: '/user/project-delivery/add-order-card-type',
    method: 'post',
    data: data,
    hideLoading: true
  });
}

// 获取公海配置列表
export function getHighSeasConfigList(data) {
  return request({
    url: '/user/user-high-seas/list',
    method: 'post',
    data: data
  });
}
// 获取公海配置人员列表
export function getHighSeasUserList(data) {
  return request({
    url: '/user/user-high-seas/user-list',
    method: 'post',
    data: data
  });
}
// 获取一级客户标签
export function getCustomerOneTag(params) {
  return request({
    url: '/orders/customer-tag/one-tag',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 获取二级客户标签
export function getCustomerTwoTag(data) {
  return request({
    url: '/orders/customer-tag/two-tag',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
// 领取/退回审核列表
export function auditReturnCustomerList(data) {
  return request({
    url: '/user/user-customer-log/audit-list',
    method: 'post',
    data: data
  });
}
// 领取/退回审核列表  获取详情
export function auditReturnCustomerInfo(data) {
  return request({
    url: '/user/user-customer-log/audit-info',
    method: 'post',
    data: data
  });
}
// 获取公海列表
export function getCustomerLogHighSeasList(params) {
  return request({
    url: '/user/user-customer-log/high-seas',
    method: 'get',
    params: params
  });
}

// 咨询工单-咨询事项选项
export function getProjectTicketSelect(params) {
  return request({
    url: '/user/project-ticket/get-select',
    method: 'get',
    params: params
  });
}

// 咨询工单-事项选项
export function getProjectTicketItem(params) {
  return request({
    url: '/user/project-ticket/get-item',
    method: 'get',
    params: params
  });
}

// 咨询工单-事项默认负责人
export function getProjectTicketItemResponsiblePerson(params) {
  return request({
    url: '/user/project-ticket/get-item-responsible-person',
    method: 'get',
    params: params
  });
}

// 咨询工单-用户选择列表（status=10 查询在职，不传查询全部）
export function getProjectTicketUserSelect(params) {
  return request({
    url: '/user/project-ticket/get-user-select',
    method: 'get',
    params: params
  });
}

// 咨询工单-添加事项咨询
export function createProjectTicket(data) {
  return request({
    url: '/user/project-ticket/create',
    method: 'post',
    data: data
  });
}

// 咨询工单-我发起的咨询工单列表
export function getProjectTicketInitiatedList(data) {
  return request({
    url: '/user/project-ticket/ticket-initiated-by-me',
    method: 'post',
    data: data
  });
}

// 咨询工单-客户订单号列表
export function getProjectTicketOrderList(params) {
  return request({
    url: '/user/project-ticket/order-list',
    method: 'get',
    params: params
  });
}

// 咨询工单-工单详情
export function getProjectTicketInfo(params) {
  return request({
    url: '/user/project-ticket/ticket-info',
    method: 'get',
    params: params
  });
}

// 咨询工单-我的待办列表
export function getProjectTicketMyToDoList(data) {
  return request({
    url: '/user/project-ticket/my-to-do',
    method: 'post',
    data: data
  });
}

// 咨询工单-全部待办列表
export function getProjectTicketAllToDoList(data) {
  return request({
    url: '/user/project-ticket/all-to-do',
    method: 'post',
    data: data
  });
}

// 咨询工单-我的待审核列表
export function getProjectTicketMyAuditList(data) {
  return request({
    url: '/user/project-ticket/my-audit',
    method: 'post',
    data: data
  });
}

// 咨询工单-分配负责人
export function allocationProjectTicket(data) {
  return request({
    url: '/user/project-ticket/allocation',
    method: 'post',
    data: data
  });
}

// 咨询工单-修改负责人
export function modifyProjectTicket(data) {
  return request({
    url: '/user/project-ticket/modify',
    method: 'post',
    data: data
  });
}

// 咨询工单-处理
export function handleProjectTicket(data) {
  return request({
    url: '/user/project-ticket/handle',
    method: 'post',
    data: data
  });
}

// 咨询工单-日志列表
export function getProjectTicketLog(params) {
  return request({
    url: '/user/project-ticket/log',
    method: 'get',
    params: params
  });
}

// 领取/退回审核列表  审核驳回
export function auditReturnCustomer(data) {
  return request({
    url: '/user/user-customer-log/audit',
    method: 'post',
    data: data
  });
}

// 报价单任务配置卡规则：创建虚拟订单
export function addVirtualOrder(data) {
  return request({
    url: '/orders/order/add-virtual-order',
    method: 'post',
    data: data
  });
}
// 订单交付信息查看
export function getOrderBaseInfo(data) {
  return request({
    url: '/orders/order/base-info',
    method: 'post',
    data: data
  });
}
// 编辑订单交付信息
export function updateOrderBaseInfo(data) {
  return request({
    url: '/orders/order/up-base-info',
    method: 'post',
    data: data
  });
}
// 报价单任务订单列表（下单/查看订单共用，按 list 是否有数据区分首次/非首次下单）
export function getSaleProjectDeliveryOrders(data) {
  return request({
    url: '/orders/order/sale-project-delivery-orders',
    method: 'post',
    data: data
  });
}
// 报价单任务下单保存：虚拟订单转正常订单
export function addSaleProjectDelivery(data) {
  return request({
    url: '/orders/order/add-sale-project-delivery',
    method: 'post',
    data: data
  });
}
// 报价单审批-佣金信息：按卡类型取佣金比例/计入业绩默认值（初审不传 source 默认 initial_review，复审传 review）
export function getProjectDeliveryCardTypeInfo(data) {
  return request({
    url: '/user/project-delivery/get-card-type-info',
    method: 'post',
    data: data
  });
}
// 报价单审批-历史订单列表：is_same_type 1 同类型历史订单 0 其他类型订单
export function getAuditProjectDeliverOrderList(data) {
  return request({
    url: '/count/order/audit-project-deliver-order-list',
    method: 'post',
    data: data
  });
}